import axios from 'axios';
require('../mock/index')
const service = axios.create({
    // if(process.env.NODE_ENV === 'development'){
    //     baseURL: 'http://139.224.25.39:9110',
    //     timeout: 5000
    // }
});

service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;